import { createAction } from '@reduxjs/toolkit';

import { NotificationData } from './notifications.types';

export const NOTIFICATIONS = '[NOTIFICATIONS]';

export const showNotification = createAction<Omit<NotificationData, 'id'>>(
  `${NOTIFICATIONS} show_notification`
);
